export default "__VITE_ASSET__ff538cc8__"